import React from "react";
import { MaterialUIGridContainer } from "core/MaterialUI";
import CollectionTitleSkeleton from "core/Collections/CollectionTitleSkeleton";
import CollectionSkeletonBox from "core/Collections/CollectionSkeletonBox";
import { Container } from "./styles";
import {
    CollectionBoxLink,
    CollectionContent,
    CollectionsGridItem,
    TextContainer
} from "core/Collections/styles";

const CollectionLoader = ({ loadingItemCount }) => {
    return (
        <Container>
            <MaterialUIGridContainer
                mobileMaxPadding={0}
                // passing in 0 means that we are not using Material UI spacing for mobile; Material UI has trouble with numbers larger than 24 on mobile, so this is done via CSS for this breakpoint.
                tabletMaxPadding={4}
                // passing in index 4 passes in the number "20" from the spacing array divided by 2 = 20px gutter as 10px around each item (see line 9 of core/MaterialUI/ for this spacing array)
                desktopMinPadding={9}
                // passing in index 9 passes in the number "48" from the spacing array divided by 2 = 48px gutter as 24px around each item (see line 9 of core/MaterialUI/ for this spacing array)
            >
                {[...Array(loadingItemCount).keys()].map(idx => {
                    return (
                        <CollectionsGridItem
                            item
                            sm={12}
                            md={4}
                            lg={4}
                            key={idx}
                        >
                            <CollectionBoxLink
                                href={"url"}
                                type={"secondary"}
                                isPhoto={false}
                            >
                                <CollectionContent>
                                    <TextContainer>
                                        <CollectionTitleSkeleton />
                                    </TextContainer>
                                    <CollectionSkeletonBox />
                                </CollectionContent>
                            </CollectionBoxLink>
                        </CollectionsGridItem>
                    );
                })}
            </MaterialUIGridContainer>
        </Container>
    );
};

export default CollectionLoader;
